<template>
    <vue-final-modal
            @opened="opened"
            v-bind="$attrs"
            v-slot="{ close }"
            :esc-to-close="true"
    >
        <div class="opui-modal opui-modal-course-edit">
            <div class="opui-modal-dialog opui-mw-900">
                <div class="opui-modal-content">
                    <div class="opui-modal-header">
                        <h1>{{ title ? title : 'Confirmation' }}</h1>
                        <i @click.prevent="close" class="opui-icon-close opui-modal-close"></i>
                    </div>

                    <div class="opui-modal-body">
                        <p>{{ text ? text : $e('Are you sure?') }}</p>

                        <div class="opui-form-actions">
                            <button class="opui-btn opui-btn-danger opui-float-right" @click="$emit('confirm', close)">
                                <span class="opui-spinner opui-spinner-border opui-text-light opui-mr-2"></span>
                                <span class="opui-btn-saving-label">Deleting...</span>
                                <span class="opui-btn-label">Delete</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </vue-final-modal>
</template>

<script>
export default {
    props: {
        title: { type: String },
        text:  { type: String },
    }
}
</script>
